import { all } from 'redux-saga/effects';
import userDataSaga from './userDetails';
import apiTokenSaga from './apiToken';
import editUserPasswordSaga from './editUserPassword';
import userEmailSaga from './userEmail';

export default function* userDetailsSaga() {
  yield all([userDataSaga(), apiTokenSaga(), editUserPasswordSaga(), userEmailSaga()]);
}
